export default __webpack_public_path__ + "static/media/alert-citron.1fd04d35.svg";